// extracted by mini-css-extract-plugin
export default {"btnsBox":"ModalAction_btnsBox__o+6kk","confirmBtn":"ModalAction_confirmBtn__acs2T"};